import { defineComponent } from "vue";

import { translateToSpanishToGestorImpuestos } from "@/common/permisos-sindicales/requests/states";

export default defineComponent({
  name: "Table",
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    show({ id }) {
      window.location.assign(`/requests-gestor-impuestos/${id}`);
    },
    translateState(state) {
      return translateToSpanishToGestorImpuestos({ state });
    },
  },
});
